'use strict'


var crypto = require('crypto-js')



var COS = require('cos-js-sdk-v5');

const protocol = window.location.protocol;
const hostname = window.location.hostname;
const port = window.location.port;
const _host = `${protocol}//${hostname}${port ? ':' + port : ''}`;

console.log("_host:",_host)

var _cos = null

export function queryVerify(id, code, expireDate, sampleText) {
  return new Promise((resolve, reject) => {
    var url = _host + `/getpassword?id=${id}&code=${code}&date=${expireDate}&text=${sampleText}`
    console.log("url:", url)
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var data = JSON.parse(this.response);
        if (!data || data.code == 0) {
          console.log("获取官方密码错误：", data.message)
          resolve('验证码错误')
          return
        }
        data = data.data
        var credentials = data.credentials;
        if (!credentials) {
          console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
          resolve(null)
        };

        _cos = new COS({
          // getAuthorization 必选参数
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          }
        })
        resolve(data.password)
      }
      //resolve(null)
    }
    xhr.send();
  })
}
export function getHost(){
  return _host
}
export function requestAuth(id) {
  //请求后台获得二维码
  let url = _host + `/requestAuth?id=${id}`

  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open('get', url)
    // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
    xhr.send()
    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          let data = JSON.parse(this.response)
          if (data.code == 0) resolve(data.data)
          else resolve(null)
        } else {
          console.log("getcaptcha err:", this.response)
          resolve(null)
        }
      }
    }
  })
}

export function waitAuth(md5,n=0) {
  let url = _host + `/captcharesult?token=${md5}`

  if(n>20)return {
    code:1 //二维码超时
  }
  return new Promise((resolve) => {
    var xhr = new XMLHttpRequest()
    xhr.open('get', url)
    // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
    xhr.send()
    xhr.onreadystatechange = async function () {
      if (this.readyState === 4) {
        if(this.status == 502 || this.status==400){
           let r = await waitAuth(md5,n+1)
           resolve(r)
        }
        else if (this.status === 200) {
          let data = JSON.parse(this.response)
          resolve(data)
        } else {
          console.log("captcharesult err:", this.response)
          await new Promise(rs => setTimeout(rs, 1000));
          let r = await waitAuth(md5,n+1);
          resolve(r)
        }
      }
    }
  })
}

export function InitCos(data) {
    _cos = new COS({
      // getAuthorization 必选参数
      getAuthorization: function (options, callback) {
              callback({
                TmpSecretId: data.credentials.tmpSecretId,
                TmpSecretKey: data.credentials.tmpSecretKey,
                SecurityToken: data.credentials.sessionToken,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
                ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
              });
        }
    })
}
export function testCos() {
  let memoID = 12121
  let url = _host + `/sts?memoID=${memoID}`

  _cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
      var xhr = new XMLHttpRequest()
      xhr.open('get', url)
      // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
      xhr.send()
      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            let data = JSON.parse(this.response)
            var credentials = data.credentials;
            if (!credentials) {
              console.error('credentials invalid')
              return
            };
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          }
        }
      }

    }
  })

  _cos.putObject({
    Bucket: 'myfile-1308181812',
    /* 填入您自己的存储桶，必须字段 */
    Region: 'ap-guangzhou',
    /* 存储桶所在地域，例如ap-beijing，必须字段 */
    Key: `${memoID}.txt`,
    /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    Body: 'this is test',
    SliceSize: 1024 * 1024 * 5,
    /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
    onTaskReady: function (taskId) {
      /* 非必须 */
      console.log("上传taskID:", taskId);
    },
    onFileFinish: function (err, data, options) {
      /* 非必须 */
      console.log(options.Key + '上传' + (err ? '失败' : '完成'));
    }
  }, function (err, data) {
    console.log(err || data);
  });


}
export function GetCosInstance() {
  return _cos
}

export function upload(id, content, readyCB, progressCB) {
  return new Promise((resolve) => {
    _cos.putObject({
      Bucket: 'myfilelink-1308181812',
      /* 填入您自己的存储桶，必须字段 */
      Region: 'ap-guangzhou',
      /* 存储桶所在地域，例如ap-beijing，必须字段 */
      Key: `${id}.txt`,
      /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      Body: content,
      SliceSize: 1024 * 1024 * 5,
      /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onTaskReady: readyCB,
      onProgress: progressCB,

    }, async function (err, data) {
      console.log('上传结果:', err || data);
      //return 
      if (!err) resolve(data)
      else resolve(false)

    })
    //_that.bUploadDlg = false
  });
}

export function submit(id,delayCode){
  var url = _host + `/submit?id=${id}&delayCode=${delayCode}`
  return new Promise((resolve) => {
 
    var xhr = new XMLHttpRequest()
    xhr.open('get', url)
    xhr.send()
    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          let r = JSON.parse(this.response)
          if (r.code == 0) {
            resolve(null)
          } else resolve(true)
        }
        resolve(null)
      }
    }
  })
}



export function Encrypted(key, content) {
  return crypto.AES.encrypt(content, key,{
    mode: crypto.mode.ECB,
    padding: crypto.pad.Pkcs7
  }).toString();
}

export function Decrypted(key, content) {
  var bytes = crypto.AES.decrypt(content, key,{
    mode: crypto.mode.ECB,
    padding: crypto.pad.Pkcs7
  });
  return bytes.toString(crypto.enc.Utf8);
}

export function SHA1(text) {
  return crypto.SHA1(text).toString()
}




// WEBPACK FOOTER //
// ./src/util.js